var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlustracionErrores({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.404,
    height: 79,
    viewBox: "0 0 82.404 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#fff;}.b,.g{fill:#19141e;}.c{fill:#dee3ff;}.c,.e,.f,.g{fill-rule:evenodd;}.d{opacity:0.396;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134.596 -274)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40,
    cy: 39.5,
    rx: 40,
    ry: 39.5,
    transform: "translate(137 274)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.596 284.526)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.958 20.539)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1318.213,1451.166h-13.246a1.308,1.308,0,1,1,0-2.617h13.246a1.308,1.308,0,1,1,0,2.617Z",
    transform: "translate(-1303.658 -1448.549)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.191 2.474)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1244.264,1421.226h0a1.308,1.308,0,0,1-1.3-1.313,5.915,5.915,0,0,1,5.884-5.883h0a1.308,1.308,0,0,1,0,2.617,3.292,3.292,0,0,0-3.275,3.275A1.308,1.308,0,0,1,1244.264,1421.226Z",
    transform: "translate(-1242.956 -1414.03)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.138 20.539)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1231.793,1451.166H1215.5a1.308,1.308,0,1,1,0-2.617h16.292a1.308,1.308,0,1,1,0,2.617Z",
    transform: "translate(-1214.192 -1448.549)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1222.7,1449.123v-34.045a5.793,5.793,0,0,1,5.774-5.776h32.185a5.792,5.792,0,0,1,5.776,5.776v34.045a5.768,5.768,0,0,1,4.754,5.661v.826a4.638,4.638,0,0,1,4.3,4.626v2.085h-61.851v-2.085a4.639,4.639,0,0,1,4.3-4.626v-.826A5.769,5.769,0,0,1,1222.7,1449.123Zm58.305-17.973a5.611,5.611,0,1,1-5.612-5.611h0A5.61,5.61,0,0,1,1281.007,1431.149Zm-74.72,0a5.611,5.611,0,1,0,5.612-5.611h0A5.611,5.611,0,0,0,1206.287,1431.149Z",
    transform: "translate(-1206.287 -1409.302)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(0.001 16.235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1217.947,1470.4v-1.432a5.834,5.834,0,0,1,5.747-5.141h41.748a5.744,5.744,0,0,1,5.747,4.953v1.62a4.638,4.638,0,0,1,4.3,4.626v2.085h-61.849v-2.085a4.638,4.638,0,0,1,4.3-4.626Zm63.062-24.46a5.611,5.611,0,1,1-5.612-5.611h0a5.61,5.61,0,0,1,5.609,5.612Zm-74.721,0a5.611,5.611,0,1,1,5.611,5.611h0a5.611,5.611,0,0,1-5.611-5.61Z",
    transform: "translate(-1206.287 -1440.325)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.028 45.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 52.746,
    height: 2.617,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.418 29.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 34.731,
    height: 3.663,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.402 13.18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1270.294,1435.794a5.741,5.741,0,1,0,8.081.785h0a5.741,5.741,0,0,0-8.081-.785",
    transform: "translate(-1268.201 -1434.486)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.602 16.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1277.186,1441.135a2.637,2.637,0,1,0,3.712.359,2.636,2.636,0,0,0-3.712-.359h0",
    transform: "translate(-1276.226 -1440.533)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.503 13.18)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1299.149,1435.794a5.741,5.741,0,1,0,8.081.785h0a5.741,5.741,0,0,0-8.081-.785",
    transform: "translate(-1297.056 -1434.486)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.703 16.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1306.042,1441.135a2.637,2.637,0,1,0,3.713.359,2.636,2.636,0,0,0-3.713-.359h0",
    transform: "translate(-1305.082 -1440.533)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracionErrores);
export default __webpack_public_path__ + "static/media/ilustracion-errores.136caca61b5e0557705e6202c5a0e86f.svg";
export { ForwardRef as ReactComponent };